// eslint-disable-next-line
import { h, Component } from 'preact';
import formatPrice from './../../utils/formatPrice';

import styles from './index.scss';

class CartInfo extends Component {
    renderQtyOfRestItems() {
        const { numbersOfItemsObj, miniCart_moreItems } = this.props;

        const invisibleItemsQty = numbersOfItemsObj.hidden;

        if (invisibleItemsQty && invisibleItemsQty > 0) {
            return <div className={styles.CartInfo__moreItems}>{`+${invisibleItemsQty} ${miniCart_moreItems}`}</div>;
        }
        return null;
    }

    renderTotalPrice() {
        const { keyword_Total, estimatedTotal, orderTotalAmount, orderIsEstimatedTotal } = this.props;

        return (
            <div>
                <div
                    className={styles.CartInfo__totalLabel}
                    dangerouslySetInnerHTML={{
                        __html: `${orderIsEstimatedTotal ? estimatedTotal : keyword_Total}: `,
                    }}
                />
                <div
                    className={styles.CartInfo__totalPrice}
                    dangerouslySetInnerHTML={{
                        __html: `${formatPrice(orderTotalAmount, styles.CartInfo__totalPriceFraction)}`,
                    }}
                />
            </div>
        );
    }

    render() {
        return (
            <div className={styles.CartInfo}>
                <div>{this.renderQtyOfRestItems()}</div>
                <div className={styles.CartInfo__total}>{this.renderTotalPrice()}</div>
            </div>
        );
    }
}

export default CartInfo;
